import React from 'react';
import { CartAccessItem, TemplateMetadata } from 'src/components/common/checkout/common';
import { MatchedTemplateWorkflow } from 'aws-sdk/clients/awsdatalakegladstonelambda';
import { TemplateRequestDetailsContainer } from 'src/components/permissions/myPermissions/templateRequestDetailsContainer';

export interface ApprovalWorkflowsAndTicketsEditorProps {
  cartItems: CartAccessItem[];
  activeGroup: string;
  activeWorkspace: any;
  // unique templates that matched.
  additionalMetadata: TemplateMetadata[];
  setAdditionalMetadata: (additionalMetadata: TemplateMetadata[]) => void;
  // all templates that matched, might have duplicate templateIds
  matchedTemplates: MatchedTemplateWorkflow[];
  username: string;
}

export const ApprovalWorkflowsAndTicketsEditor = (props: ApprovalWorkflowsAndTicketsEditorProps) => {
  return (
    <TemplateRequestDetailsContainer
      additionalMetadata={props.additionalMetadata}
      setAdditionalMetadata={props.setAdditionalMetadata}
    />
  );
};
